"use client";

import FooterSiteLayout from "./internal/FooterSiteLayout";
import { FooterComponentProps } from "./types";

const FooterDefaultV2 = (props: FooterComponentProps) => <FooterSiteLayout {...props} />;

export default FooterDefaultV2;
